import { Injectable } from '@angular/core';
import { AvailableOptions, IntervalService, Options, SetOptionsPayload } from '@checkout/const';
import { CheckoutActions, CheckoutSelectors, StateWithCustomCheckout } from '@checkout/data-access';
import { select, Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';
import { TimeSlotsService } from './time-slots.service';

@Injectable({
  providedIn: 'root',
})
export class AdditionalOptionsService {
  constructor(
    private store: Store<StateWithCustomCheckout>,
    private timeSlotsService: TimeSlotsService,
  ) {}

  refreshOptions(): void {
    this.store.dispatch(new CheckoutActions.LoadOptions());
  }

  getOptions(): Observable<Options> {
    return this.store.pipe(select(CheckoutSelectors.getOptions));
  }

  getAvailableOptions(): Observable<AvailableOptions> {
    return combineLatest([this.getOptions(), this.timeSlotsService.getCurrentTimeSlot()]).pipe(
      map(([options, timeSlot]) => {
        const availableOptions: AvailableOptions = {};

        if (options && timeSlot) {
          if (timeSlot.services.includes(IntervalService.Unload) && options.unloading) {
            availableOptions.unloading = {
              ...options.unloading,
            };
          }
          if (timeSlot.services.includes(IntervalService.Uplift) && options.lifting) {
            availableOptions.lifting = {
              ...options.lifting,
            };
          }
        }

        return availableOptions;
      }),
    );
  }

  getActiveOptions(): Observable<any> {
    return this.store.pipe(select(CheckoutSelectors.getActiveOptions));
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getOptionsLoading));
  }

  setActiveOptions(options: SetOptionsPayload): void {
    this.store.dispatch(new CheckoutActions.SetOptions(options));
  }
}
